import styled from 'styled-components';

/* Functional components may house styles */
const HeaderStyled = styled.header`
    width: 100vw;
    position: fixed;
    display: flex;
    top: 0;
    justify-content: flex-end;
    background-color: ${props =>
        props.scrolled || props.isMobile ? '#fff' : 'transparent'};
    transition: background-color 0.2s linear;
    min-height: 80px;
    z-index: 9999;

    .mobile-navigation-list {
        position: absolute;
        width: 100vw;
        z-index: -1;
        background-color: white;
        padding-top: 80px;
        top: -500px;
        padding: 80px 20px;
        display: flex;
        flex-direction: column;
        align-items: center;

        li {
            width: 90%;
            list-style-type: none;
        }
        a {
            font-size: 1.5em;
            text-decoration: none;
            padding: 15px 25px;
            font-weight: bold;
            font-style: italic;
            color: #54565b;
            display: block;
            border-top: solid 1px #e4e2db;

            &:hover {
                color: #abc7ca !important;
            }
        }
    }

    .navigation-list {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        list-style-type: none;
        width: 50%;
        padding: 0;
        margin: 0;
        margin-right: 20px;
        a {
            transition: color 0.3s linear;
            transition: border-bottom 0.3s linear;
            border-bottom: 0px solid #fff;
            text-decoration: none;
            margin: 36px 36px 0px 36px;
            padding-bottom: 16px;
            font-weight: bold;
            font-style: italic;
            font-size: 0.8em;
            display: block;
            color: ${props => (props.scrolled ? '#54565b' : '#fff')};
        }
        a:hover {
            border-bottom: solid 4px #fff !important;
            color: ${props => (props.scrolled ? '#abc7ca !important' : '#fff')};
        }
    }

    button {
        border-radius: 3px;
        width: 32px;
        height: 32px;
        background-color: #54565b;
        border: none;
        display: block;
        position: absolute;
        top: 25px;
        right: 50px;

        img {
            width: 55%;
        }
    }

    .pilot-logo {
        width: ${props => (!props.isMobile ? '8%' : '20%')};
        position: absolute;
        left: 50px;
        top: 25px;
        display: block;
        max-width: 112px;
    }
`;

export default HeaderStyled;
